export const CUSTOM_CONTENT_TYPE = {
  omit: 'omit',
  custom: 'custom',
};

export const CONTENT_TYPE_HEADER = 'content-type';

export const HTTP_METHODS = {
  GET: 'GET',
  PUT: 'PUT',
  POST: 'POST',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};

export const ACTION_TYPES = {
  start: 'start',
  pause: 'pause',
  cancel: 'cancel',
};

export const FIELD_UPDATE_MODE = {
  UPDATE_FIELDS: 'update_fields',
  CLEAR_FIELDS: 'clear_fields',
} as const;
